import { BillState, CorrectedBill } from '@mews-commander/data-access';
import { RouteName } from '@mews-commander/enums';
import { Dash } from '@mews-commander/ui';
import { useResolveRoute } from '@mews/routing';
import { useBillingUrl } from '../../../../components/commander-ui/connected/BillLink/useBillingUrl';
import { ModalLink } from '../../../../components';

interface BillLinkWithBillIdProps {
    bill: CorrectedBill;
}

export const CorrectionBillCorrectedBillLink = ({ bill }: BillLinkWithBillIdProps) => {
    const billingUrl = useBillingUrl({
        accountId: bill.ownerId,
        billId: bill.id,
    });
    const resolveRoute = useResolveRoute();

    if (!bill) return <Dash />;

    const url =
        bill.state !== BillState.Closed && billingUrl
            ? billingUrl
            : resolveRoute(RouteName.BillDetail, { id: bill.id });

    return (
        <ModalLink data-bill-link={bill.id} url={url}>
            {bill.name}
        </ModalLink>
    );
};
